import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';
import NoPermission from "../../common/NoPermission";
import LoaderSpinner from "../../common/LoaderSpinner";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getAllRegistrations, getAdmissionPageInfo, clearRegistrations, getRegistrationsByFilter } from '../../api/admissionApi';
import { updateAdmissionPageInfo } from "../../../actions/admissionAction";
import RegistrationInfo from "./RegistrationInfo";

const defaultValues = {
  formNo: '',
  courseType: 'none',
  feeStatus: 'none',
  subject: 'none',
  course: 'none'
};

const MASubjects = [
  'English',
  'Sociology',
  'PoliticalScience',
  'Hindi',
  'Geography'
];


const SearchRegistrations = ({ permissions = {}, isSuperAdmin }) => {
  const [showFilters, toggleFilters] = useState(true);
  const [filters, setFilters] = useState(defaultValues);
  const [isFilterSelected, setFilterSelected] = useState(false);
  const [showRegInfo, toggleRegInfo] = useState(false);
  const [selectedReg, setSelectedReg] = useState({});

  const dispatch = useDispatch();
  const getAllStudentRegistrations = (ecb) => dispatch(getAllRegistrations(ecb));
  const clearData = () => dispatch(clearRegistrations());

  const state = useSelector(state => state);
  const { admissionReducer: { fetchingReg, filteredReg = [], admissionPageInfo = {}, isFetchingExistingAdmsnPageInfo } = {} } = state || {};
  const { info: courseInfo = {} } = admissionPageInfo;
  const [showTooltip, setShowTooltip] = useState(false);


  useEffect(() => {
    const callbacks = {
      successCallback: admissionPageInfoSuccess,
      failureCallback: admissionPageInfoFailure,
    };
    dispatch(
      getAdmissionPageInfo(
        { year: moment(new Date()).format("YYYY") },
        callbacks
      )
    );
    resetFilters();
    clearData();
  }, []);

  const admissionPageInfoSuccess = (data) => {
    dispatch(updateAdmissionPageInfo(data));
  };

  const admissionPageInfoFailure = () => toast.error("Some error occured, please try again!");

  const onChangeFilters = (filterName = '', value = '') => {
    let isChanged = false;
    const newFilters = { ...filters, [filterName]: value.trimStart() };
    Object.keys(defaultValues).forEach(key => {
      if (defaultValues[key] !== newFilters[key]) {
        isChanged = true;
      }
    });

    if (filterName === 'courseType') {
      newFilters['course'] = 'none';
    }

    setFilters(newFilters);
    setFilterSelected(isChanged);
  }

  const onViewAction = (reg = {}) => {
    setSelectedReg(reg);
    toggleRegInfo(true);
  };

  const handleClose = () => {
    setSelectedReg({});
    toggleRegInfo(false);
  }

  const resetFilters = () => {
    setFilters(defaultValues);
    setFilterSelected(false);
  }

  const fetchRegistrationsByFilter = () => {
    const payload = {
      formNumber: filters.formNo === 'none' ? '' : filters.formNo,
      registrationType: filters.courseType === 'none' ? '' : filters.courseType,
      paymentStatus: filters.feeStatus === 'none' ? '' : filters.feeStatus,
      subjects: filters.subject === 'none' ? [] : [filters.subject],
      courseName: filters.course === 'none' ? '' : filters.course
    };
    dispatch(getRegistrationsByFilter(payload, errorCallback));
  }

  const fetchAllRegistrations = () => {
    getAllStudentRegistrations(errorCallback);
  }

  const errorCallback = (err) => {
    if (err.data.registrations === "No registrations found with provided filters") toast.error(err.data.registrations, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
    else
      toast.error("Invalid filters passed!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
  }

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Search registrations</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Search registrations
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderRegistrartions = () => {
    if (!filteredReg.length) return null;
    return (
      <div className="table-responsive card">
        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
          <thead>
            <tr>
              <th style={{ borderRight: "1px solid #eee" }}>Form No.</th>
              <th style={{ borderRight: "1px solid #eee" }}>Name</th>
              <th style={{ borderRight: "1px solid #eee" }}>Email Id</th>
              <th style={{ borderRight: "1px solid #eee" }}>Phone</th>
              <th style={{ borderRight: "1px solid #eee" }}>Roll No.</th>
              <th style={{ borderRight: "1px solid #eee" }}>Actions</th>
              <th>Payment/Reg. Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredReg.map((reg = {}, idx) => {
              const { full_name: { first_name = '', last_name = '' } = {} } = reg;
              return (
                <tr key={idx}>
                  <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{reg.formNumber ? reg.formNumber : '-'}</td>
                  <td style={{ borderRight: "1px solid #eee" }}><span className="font-16">{`${first_name} ${last_name}`}</span></td>
                  <td style={{ borderRight: "1px solid #eee" }}>{reg.email_id}</td>
                  <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{reg.mobile_number}</td>
                  <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>
                    {reg.rollNo || '-'}
                  </td>
                  <td style={{ borderRight: "1px solid #eee" }}>
                    <button type="button" className="btn btn-outline-primary" onClick={() => onViewAction(reg)} >View Full Profile</button>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {
                      (reg.payment_status?.isCollegeFeePaid && reg.payment_status?.collegeFeesPaidDate) ? <span style={{ background: 'limegreen' }}>{`Paid & Verified`}</span> :
                        (reg.payment_status?.isCollegeFeePaid && !reg.payment_status?.collegeFeesPaidDate) ? <span>Paid</span> :
                          <span>{`Un-Paid`}</span>
                    }
                    /
                    {` (Reg. `}
                    {reg.is_registration_completed ? <span style={{ background: 'limegreen' }}>{'Complete'}</span> : <span style={{ background: 'yellow' }}>{'Pending'}</span>}
                    {`)`}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const renderFilterSection = () => {

    let selectedFilters = '';
    let courses = [];

    Object.keys(filters).forEach(key => {
      if (filters[key] !== defaultValues[key]) {
        selectedFilters = selectedFilters + key + ': ' + filters[key] + '; ';
      }
    })

    if (filters['courseType'] === 'Bachelors') {
      courses = Object.keys(courseInfo['Bachelors']).map(key => courseInfo['Bachelors'][key].course_name);
    } else if (filters['courseType'] === 'Masters') {
      courses = Object.keys(courseInfo['Masters']).map(key => courseInfo['Masters'][key].course_name);
    }

    return (
      <div className="accordion" id="accordionExample">
        <div className="card" style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}>
          <div className="card-header p-0" id="headingOne">
            <h2 className="mb-0 d-flex align-items-center" style={{ width: "100%" }}>
              <button className="btn btn-block text-left btn-focus" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={() => toggleFilters(!showFilters)}>
                <h4 className="text-line pl-1">Filters</h4>
              </button>
              {showFilters ?
                <i className="fa fa-angle-up text-arrow pr-3 mb-1" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => toggleFilters(!showFilters)}></i> :
                <i className="fa fa-angle-down text-arrow pr-3 mb-1" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => toggleFilters(!showFilters)}></i>
              }
            </h2>
          </div>
          <div id="collapseOne" className={`collapse ${showFilters ? 'show' : ''}`} aria-labelledby="headingOne" data-parent="#accordionExample">
            <div className="card-body pt-0 pb-2">
              <div className="d-flex justify-content-between mb-3">
                <h6 className="mb-0">Filter By</h6>
                <div className="link" style={{ textDecoration: 'underline' }} onClick={resetFilters}>Reset Filters</div>
              </div>
              <div className="d-flex mb-4 align-items-center">
                Form/Registration Number:
                <input type="text" className="form-control w-25 ml-3" placeholder="Reg. no" value={filters['formNo']} onChange={(e) => onChangeFilters('formNo', e.target.value)} />
              </div>
              <div className="d-flex align-items-center pt-2 pb-2">
                <FormControl sx={{ width: 150, marginRight: 3 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Course Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Course Type"
                    value={filters['courseType']}
                    onChange={(e) => onChangeFilters('courseType', e.target.value)}
                  >
                    <MenuItem value="none">--Select--</MenuItem>
                    <MenuItem value="Bachelors">UG</MenuItem>
                    <MenuItem value="Masters">PG</MenuItem>
                  </Select>
                </FormControl>

                <FormControl sx={{ width: 150, marginRight: 3 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Course
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Course"
                    value={filters['course']}
                    onChange={(e) => onChangeFilters('course', e.target.value)}
                  >
                    <MenuItem value="none">--Select--</MenuItem>
                    {courses.map((cor, idx) => {
                      return <MenuItem value={cor} key={idx}>{cor}</MenuItem>;
                    })}
                  </Select>
                </FormControl>

                {filters.course === 'MA' && (<FormControl sx={{ width: 150, marginRight: 3 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Subject
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Subject"
                    value={filters['subject']}
                    onChange={(e) => onChangeFilters('subject', e.target.value)}
                  >
                    <MenuItem value="none">--Select--</MenuItem>
                    {MASubjects.map((sub, idx) => {
                      return <MenuItem key={idx} value={sub}>{sub}</MenuItem>
                    })}
                  </Select>
                </FormControl>)}

                <FormControl sx={{ width: 150 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Entrance Fee Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Entrance Fee Status"
                    value={filters['feeStatus']}
                    onChange={(e) => onChangeFilters('feeStatus', e.target.value)}
                  >
                    <MenuItem value="none">--Select--</MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>
                    <MenuItem value="unpaid">Unpaid</MenuItem>
                  </Select>
                </FormControl>
                <div className="d-flex align-items-center">
                  <i
                    className="fa fa-exclamation-circle ml-1"
                    aria-hidden="true"
                    style={{
                      color: "orange",
                      fontSize: "1.2em",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                  ></i>
                  {showTooltip && (
                    <div className="ml-3" style={{ color: "red" }}>
                      Please note that the entrance fee status filter is not meant for complete course fees payment.
                    </div>
                  )}
                </div>

              </div>
              <div className="d-flex align-items-center mt-3">
                <button className="btn btn-primary" type="button" disabled={fetchingReg || !isFilterSelected || isFetchingExistingAdmsnPageInfo} onClick={fetchRegistrationsByFilter}>
                  Search
                </button>
                <h6 className="ml-3 mr-3">Or instead...</h6>
                <button className="btn btn-outline-primary" type="button" onClick={fetchAllRegistrations} disabled={fetchingReg || isFetchingExistingAdmsnPageInfo}>
                  Get Full List
                </button>
              </div>
              <div className="d-flex mt-3">
                <div style={{ fontSize: "12px", textTransform: 'capitalize' }}>Selected Filters: [{`${selectedFilters}`}]</div>
                <div className="ml-3" style={{ fontSize: "12px", textTransform: 'capitalize' }}>Total Results: {`${filteredReg.length}`}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header pb-0 justify-content-between">
          <h3 className="card-title">Search from all registrations</h3>
          {fetchingReg && (
            <div>
              <span className="mr-2">Fetching Registrations</span>
              <LoaderSpinner />
            </div>
          )}
          {isFetchingExistingAdmsnPageInfo && (
            <div>
              <span className="mr-2">Loading</span>
              <LoaderSpinner />
            </div>
          )}
        </div>
        <div className="card-body">
          {renderFilterSection()}
          {renderRegistrartions()}
        </div>
      </div>
    );
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }
  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
      {showRegInfo && <RegistrationInfo selectedReg={selectedReg} showRegInfo={showRegInfo} handleClose={handleClose} />}
    </Fragment>
  );
}

export default SearchRegistrations;
